// @flow
export const INIT_COOKIE_POLICY_SETTINGS: 'INIT_COOKIE_POLICY_SETTINGS' =
    'INIT_COOKIE_POLICY_SETTINGS';
export const UPDATE_COOKIE_POLICY_SETTINGS: 'UPDATE_COOKIE_POLICY_SETTINGS' =
    'UPDATE_COOKIE_POLICY_SETTINGS';
export const CONSENT_COOKIE_POLICY: 'CONSENT_COOKIE_POLICY' = 'CONSENT_COOKIE_POLICY';
